<template>
  <div class="popup-filter">
    <form @submit.prevent="onSubmit">
      <h4 class="filter-title">Filter Channels</h4>
      <div class="form-group">
        <input
          type="text"
          class="search-box form-control"
          placeholder="Search channels"
          v-model="filters.search"
        />
      </div>
      <div class="form-group">
        <div class="status-list d-flex justify-content-between">
          <div
            class="rounded-button"
            v-for="(s, index) of approvalStatuses"
            :key="index"
            @click="toggleStatus(s.value)"
            :class="{
              selected: filters.approvalStatuses.indexOf(s.value) > -1,
            }"
          >
            {{ s.label }}
          </div>
        </div>
      </div>
      <div class="form-group">
        <select v-model="filters.sort" class="form-control">
          <option
            v-for="(item, index) of sortOptions"
            :key="index"
            :value="item.value"
          >
            {{ item.label }}
          </option>
        </select>
      </div>
      <div class="form-group">
        <h5 class="filter-category-title">Type</h5>
        <div class="group-type-list d-flex flex-wrap">
          <div
            class="rounded-button"
            v-for="(t, index) of groupTypes"
            :key="index"
            @click="toggleGroupType(t.value)"
            :class="{ selected: filters.types.indexOf(t.value) > -1 }"
          >
            {{ t.label }}
          </div>
        </div>
      </div>
      <div class="form-actions d-flex justify-content-between">
        <button type="submit" class="btn submit-button">
          <span>Apply</span>
          <img :src="icons.approvedIcon" />
        </button>
        <button type="reset" class="btn reset-button" @click.prevent="reset">
          <span>Reset Filters</span>
          <img :src="icons.resetIcon" />
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import approvedIcon from "@/assets/images/icons/ew-icon_approved.svg";
import resetIcon from "@/assets/images/icons/ew-icon_reset.svg";
import { merge } from "lodash";

const sortOptions = [
  {
    label: "Sort by name A...Z",
    value: {
      sortBy: "name",
      sortAscending: true,
    },
  },
  {
    label: "Sort by name Z...A",
    value: {
      sortBy: "name",
      sortAscending: false,
    },
  },
  {
    label: "Sort by Listing Date",
    value: {
      sortBy: "updatedAt",
      sortAscending: false,
    },
  },
  {
    label: "Sort by number of experiences high...low",
    value: {
      sortBy: "stats.experienceCount",
      sortAscending: false,
    },
  },
  {
    label: "Sort by number of experiences low...high",
    value: {
      sortBy: "stats.experienceCount",
      sortAscending: true,
    },
  },
  {
    label: "Sort by fees high...low",
    value: {
      sortBy: "fee",
      sortAscending: false,
    },
  },
  {
    label: "Sort by fees low...high",
    value: {
      sortBy: "fee",
      sortAscending: true,
    },
  },
];

const approvalStatuses = [
  {
    label: "Connected",
    value: "approved",
  },
  {
    label: "Requested",
    value: "pending",
  },
  {
    label: "Rejected",
    value: "rejected",
  },
];

const groupTypes = [
  {
    label: "Association",
    value: "association",
  },
  {
    label: "Certification",
    value: "certification",
  },
  {
    label: "Brand",
    value: "brand",
  },
  {
    label: "NGO",
    value: "ngo",
  },
  {
    label: "Others",
    value: "others",
  },
];

const defaultFilters = {
  search: "",
  sort: sortOptions[0].value,
  approvalStatuses: [],
  types: [],
};

export default {
  data() {
    return {
      icons: {
        approvedIcon,
        resetIcon,
      },
      filters: merge({}, defaultFilters),
      sortOptions,
      approvalStatuses,
      groupTypes,
    };
  },
  methods: {
    onSubmit() {
      let filters = merge({}, this.filters);
      filters.sortBy = filters.sort.sortBy;
      filters.sortAscending = filters.sort.sortAscending;
      delete filters.sort;
      this.$emit("search", filters);
    },
    reset() {
      this.filters = merge({}, defaultFilters);
    },
    toggleStatus(status) {
      const index = this.filters.approvalStatuses.indexOf(status);
      if (index > -1) {
        this.filters.approvalStatuses.splice(index, 1);
      } else {
        this.filters.approvalStatuses.push(status);
      }
    },
    toggleGroupType(type) {
      const index = this.filters.types.indexOf(type);
      if (index > -1) {
        this.filters.types.splice(index, 1);
      } else {
        this.filters.types.push(type);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.popup-filter {
  font-size: 12px;

  input,
  select {
    font-size: 12px;
  }

  .filter-title {
    font-size: 18px;
    color: var(--color-blue-sky);
  }

  .filter-category-title {
    font-size: 14px;
    margin: 30px 0 10px;
  }

  button {
    padding-left: 0;
    padding-right: 0;
    position: relative;

    img {
      width: 20px;
      position: absolute;
      right: 10px;
    }
  }

  .submit-button {
    background-color: var(--color-blue-sky);
    width: 48%;
    font-size: 14px;
  }
  .reset-button {
    background-color: var(--color-gray);
    width: 48%;
    font-size: 14px;
  }

  .group-type-list {
    .rounded-button {
      text-transform: uppercase;
    }
  }

  .rounded-button {
    border-radius: 15px;
    background-color: var(--color-blue-sky);
    color: #fff;
    font-size: 12px;
    text-align: center;
    display: inline-block;
    padding: 4px 20px;
    margin-right: 20px;
    margin-bottom: 10px;
    cursor: pointer;
    user-select: none;

    &:hover,
    &.selected {
      background-color: var(--color-blue-sky-active);
    }
  }
}
</style>